/* ==========================================================================
   OliveDrab — the phone hero slider (01 / Explore)

   The pictures sit on top of one another and fade from one to the next on
   their own. A swipe moves by hand, the dots jump straight to one, and the
   clock rests while the hero is off screen or the tab is hidden. Nothing here
   runs on a desktop, where the slider is not shown.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function bind(root) {
    if (root.dataset.odSlidesBound) return;
    root.dataset.odSlidesBound = '1';

    var slides = $$('.od-hero1__mslide', root);
    var dots = $$('[data-od-slide-dot]', root);
    if (slides.length < 2) return;

    var seconds = parseFloat(root.getAttribute('data-seconds')) || 4;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var at = 0;
    var timer = null;
    var held = {};

    /* a slide is the picture itself, or the link wrapped around it when the
       merchant has sent that picture to a collection */
    function pictureIn(el) { return el.tagName === 'IMG' ? el : el.querySelector('img'); }

    function show(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === at;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        /* only the picture on show may be clicked or tabbed to */
        if (s.tagName === 'A') {
          if (on) s.removeAttribute('tabindex');
          else s.setAttribute('tabindex', '-1');
        }
        /* the next picture is fetched before its turn, so it never fades in blank */
        if (n === (at + 1) % slides.length) {
          var next = pictureIn(s);
          if (next && next.loading === 'lazy') next.loading = 'eager';
        }
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-on', n === at);
        d.setAttribute('aria-current', n === at ? 'true' : 'false');
      });
    }

    function running() {
      if (reduce) return false;
      for (var k in held) if (held[k]) return false;
      return true;
    }
    function schedule() {
      window.clearTimeout(timer);
      if (!running()) return;
      timer = window.setTimeout(function () { show(at + 1); schedule(); }, seconds * 1000);
    }
    function hold(why, on) { held[why] = on; if (on) window.clearTimeout(timer); else schedule(); }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); schedule(); });
    });

    /* a sideways swipe moves one picture; an upward drag is left to the page */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY;
      hold('hand', true);
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 !== null) {
        var t = e.changedTouches[0];
        var dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
      }
      x0 = null;
      hold('hand', false);
    }, { passive: true });
    root.addEventListener('touchcancel', function () { x0 = null; hold('hand', false); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { hold('away', !en.isIntersecting); });
      }, { threshold: 0.1 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { hold('hidden', document.hidden); });

    show(0);
    schedule();
  }

  function boot(scope) { $$('[data-od-hero-slides]', scope || document).forEach(bind); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
